// extracted by mini-css-extract-plugin
export default {"container":"mca-z","productName":"nca-z","price":"oca-z","dimensions":"pca-z"};